@use "../../../../css/variables/dashboard.scss";
@use '~@frontrow/console/css/variables.scss';

@forward "../../../../css/variables/dashboard.scss";
@forward '~@frontrow/console/css/variables.scss';

.dashboardMainContentWrapper {
  margin-left: dashboard.$sidebar-width;
}

.dashboardMainContent {
  margin-left: variables.$std-margin-lg;
  margin-right: variables.$std-margin-lg;
}
